import React, { MouseEventHandler } from "react";
import { FontAwesomeIcon } from "@nef/core"

const CopyClipboardIcon = ({ onClick } : {onClick : MouseEventHandler<HTMLElement>}) => {
  return (
    <span>
      <FontAwesomeIcon
        iconClassName="fa-icon fa-copy"
        onClick={onClick}
        data-testid="copyClipboard"
      />
    </span>)
}

const MemoizedIcon = React.memo(CopyClipboardIcon);
export default MemoizedIcon;